export default {

    LOGIN : 'login',
    SIGNUP : 'signup',
    PASSWORD_REST : 'password_reset',
    LOGIN_AS_USER : 'login_as_user',

    DASHBOARD : 'dashboard',
    SETTINGS : 'settings',
    ACCOUNT : 'account',

    ORDERS_INDEX : 'orders.index',
    ORDERS_VIEW : 'orders.view',

    PRODUCTS_INDEX : 'products.index',
    PRODUCTS_VIEW : 'products.view',

    CART : 'cart',
}
